import { BaseError } from './base';

type WalletProviderMethodUnavailableErrorParams = {
  methodName: string;
  walletProviderKey: string;
};

export class WalletProviderMethodUnavailableError extends BaseError {
  constructor({
    methodName,
    walletProviderKey,
  }: WalletProviderMethodUnavailableErrorParams) {
    super({
      cause: null,
      code: 'wallet_provider_method_unavailable_error',
      docsUrl: null,
      name: 'WalletProviderMethodUnavailableError',
      shortMessage: `Wallet provider ${walletProviderKey} does not have ${methodName} available`,
    });
  }
}
